/** Caves: format, sets, building, validation (docs/spec/03). */

import type { CaveDef, CaveSet, CaveSetId } from './types';
import { CLASSIC } from './classic';
import { DEEP } from './deep';

export { CLASSIC, DEEP };
export { buildCave, levelOf, mapSize } from './build';
export { charOf, dumpCave, LEGEND } from './legend';
export { describeIssues, diamondPotential, reachable, validateCave } from './validate';
export type { CaveIssue, CaveKind } from './validate';
export type * from './types';

/** The order caves are played in: four caves, then an intermission (docs/spec/01 §1). */
export const PLAY_ORDER = 'ABCDQEFGHRIJKLSMNOPT';

/** Where the player may start: A, E, I or M. */
export const START_CAVES = 'AEIM';

export function caveSet(id: CaveSetId): CaveSet {
  return id === 'deep' ? DEEP : CLASSIC;
}

export function findCave(set: CaveSet, id: string): CaveDef | undefined {
  return set.caves.find((c) => c.id === id);
}

/** The set's caves in play order (skipping any letter the set does not have yet). */
export function playOrder(set: CaveSet): CaveDef[] {
  return [...PLAY_ORDER].map((id) => findCave(set, id)).filter((c): c is CaveDef => c !== undefined);
}
